export default __webpack_public_path__ + "static/media/tvvl-logo.5de930fd.svg";